import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bc3ef1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "The Mana World Project", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The Mana World (TMW) is a serious effort to create an innovative free and open source MMORPG. TMW uses 2D graphics and aims to create a large and diverse interactive world. It is licensed under the GPL, making sure this game can't ever run away from you.", -1))
const _hoisted_4 = { class: "read-more" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Recent News", -1))
const _hoisted_6 = { class: "read-more" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_News = _resolveComponent("News")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, { to: { name: 'about' } }, {
        default: _withCtx(() => [
          _createTextVNode("Read More »")
        ]),
        _: 1
      })
    ]),
    _hoisted_5,
    _createVNode(_component_News, { count: 1 }),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, { to: { name: 'news' } }, {
        default: _withCtx(() => [
          _createTextVNode("More News »")
        ]),
        _: 1
      })
    ])
  ]))
}